module.exports = __webpack_public_path__ + "img/code.64caf8a1.png";